import { render } from "./CollaborationView.vue?vue&type=template&id=dae18f98"
import script from "./CollaborationView.vue?vue&type=script&lang=js"
export * from "./CollaborationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__